import settings from "../../data/settings.json";
// import manifestJson from "../../manifest.json";

const { buildings } = settings;
// const manifestData = manifestJson.data;
const state = buildings.reduce((initialState, building) => {
	const db = require(`../../data/${building}.json`);
	initialState[building] = JSON.parse(JSON.stringify(db.medias));
	return initialState;
}, {});
export default state;
